interface SseMessage {
  readonly id?: string;
  readonly event: string;
  readonly data: string;
}

export function sseReader(): (chunk: string) => SseMessage[] {
  let buffer = "";
  let data: string[] = [];
  let event = "";
  let id: string | undefined;
  return (chunk) => {
    buffer += chunk;
    const lines = buffer.split(/\r\n|\r|\n/);
    buffer = lines.pop() ?? "";
    const messages: SseMessage[] = [];
    for (const line of lines) {
      if (line === "") {
        if (data.length > 0 || id !== undefined) messages.push({ ...(id === undefined ? {} : { id }), event: event || "message", data: data.join("\n") });
        data = [];
        event = "";
        id = undefined;
        continue;
      }
      if (line.startsWith(":")) continue;
      const colon = line.indexOf(":");
      const field = colon < 0 ? line : line.slice(0, colon);
      const value = colon < 0 ? "" : line.slice(colon + 1).replace(/^ /, "");
      if (field === "data") data.push(value);
      else if (field === "event") event = value;
      else if (field === "id") id = value;
    }
    return messages;
  };
}

export function backoff(failures: number): number {
  return [1000, 2000, 4000, 8000][failures - 1] ?? 15_000;
}
